import React, { Suspense } from "react";

//components
import Modal from "@/shared/Modal";
import SelectCampaignModalContentLoading from "./component/SelectCampaignModalContentLoading";
const SelectCampaignModalContent = React.lazy(() => import("./component/SelectCampaignModalContent"));

// helpers
import campaigns from "@/api/query/campaigns";

// interfaces
import { IPaginatedResponse } from "@/types/api/PaginatedResponse";
import { ICampaign } from "@/types/api/Campaign";

// assets
import styles from "@/assets/styles/components/Modals/select-campaign-modal.module.scss";

interface ISelectCampaignModal {
  open: boolean;
  onCancel: () => void;
}

const SelectCampaignModal = ({ open, onCancel }: ISelectCampaignModal) => {
  const {
    data: allCampaigns = {} as IPaginatedResponse<ICampaign>,
    isLoading: isCampaignLoading,
  } = campaigns.useGetAllCampaigns({
    params: { status: 0 },
    config: { enabled: open }
  });

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      destroyOnClose={true}
      centered
      footer={null}
      title="Select campaign"
      className={styles["locl-select-campaign-modal"]}
    >
      <Suspense fallback={<SelectCampaignModalContentLoading />}>
        <SelectCampaignModalContent
          allCampaigns={allCampaigns}
          isLoading={isCampaignLoading}
          onCancel={onCancel}
        />
      </Suspense>
    </Modal>
  )
};

export default SelectCampaignModal;
